<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 16 16"
    enable-background="new 0 0 16 16"
    xml:space="preserve"
    class="icon icon--ceintre"
    fill="currentColor"
  >
    <path
      d="M15.3,14.2H0.8c-0.3,0-0.6-0.2-0.7-0.5c-0.1-0.3,0-0.6,0.3-0.8l6.5-5L7,8.2C7,8.1,7,8.1,7,8V7
	c0-0.4,0.3-0.8,0.8-0.8C8.4,6.2,9,5.7,9,5S8.4,3.8,7.8,3.8S6.5,4.3,6.5,5H5c0-1.5,1.2-2.8,2.8-2.8s2.8,1.2,2.8,2.8
	c0,1.2-0.8,2.3-2,2.6l7.2,5.3c0.3,0.2,0.4,0.5,0.3,0.8C15.9,14,15.6,14.2,15.3,14.2z M3,12.8h10L7.4,8.6l0.3,0.4L3,12.8z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CeintreIcon',
}
</script>
